/**
 * Ids d'onglets des panneaux llm-config, partagés entre le manifest et les
 * vues qui les ouvrent ou les activent.
 */
export const LLM_PRESET_PREVIEW_TAB = 'llm-preset-preview';
